import React from 'react';
import { Container } from 'react-bootstrap';
import LinkedIssue from './LinkedIssue';
import WebLinks from './WebLinks';

const TraceabilityComponent = ({ entityId, entityType, entityKey }) => {
  return (
    <Container fluid className="px-0">
      <LinkedIssue entityId={entityId} entityType={entityType} entityKey={entityKey} />
      <WebLinks entityId={entityId} entityType={entityType} />
    </Container>
  );
};

export default TraceabilityComponent;
